import React from "react";
import { Modal } from "antd";
import { Button } from "components/Button";
import { CheckCircleFilled, CloseOutlined, } from "@ant-design/icons";
import "../styles/addStaffDrawer.css";
import imagePath from "../../../Assets/userManagementV3/confirmModalPic.png";
import successImage from "../../../Assets/ill-submitted.svg"
import { fluid } from "../utils/responsive";

const AddStaffSuccessModal = ({
    visible,
    staffName,
    role,
    onCancel,
    onComplete,
}) => {

    return (

        <Modal
            // className="modal-round-corner"
            visible={visible}
            footer={null}
            centered
            closable={false}
            width={480}
            className="add-staff-success-modal"
        >

            <div className="success-body">
                
                <img src={successImage} alt="Success" style={{width: fluid(110), height: fluid(110)}} />

                <div className="success-title">
                    {String(role || "").toLowerCase().includes("operation") ? "Operations" : (role || "Staff")} added!
                </div>

                <div className="success-description">
                    <span className="success-font">{staffName}</span> has been added successfully.
                </div>

                <div className="success-buttons">

                    <button
                        className="later-btn"
                        onClick={onCancel}
                    >
                        DO IT LATER
                    </button>

                    <Button
                        type="primary"
                        onClick={onComplete}
                    >
                        COMPLETE PROFILE
                    </Button>

                </div>

            </div>

        </Modal>

    );

};

export default AddStaffSuccessModal;